// @ts-nocheck
import { ref } from "vue";

const socket = ref(null);
let reconnectAttempts = 0;

function getAgentId() {
  return window.EDRONE_CONTEXT ? window.EDRONE_CONTEXT.user.agentId : window._user_agent_id;
}
function getTrackerId() {
  return window.EDRONE_CONTEXT ? window.EDRONE_CONTEXT.trackerId : window._user_tracker_id;
}

export function useInboxWebSocket(onMessage) {
  const connect = () => {
    const agentId = getAgentId();
    const trackerId = getTrackerId();

    socket.value = new WebSocket(
      `wss://qev7les36f.execute-api.eu-west-1.amazonaws.com/PROD?agent_id=${agentId}&tracker_id=${trackerId}`
    );

    socket.value.onopen = () => {
      reconnectAttempts = 0;
    };

    socket.value.onmessage = (event) => {
      if (onMessage) {
        onMessage(event);
      }
    };

    socket.value.onclose = () => {
      reconnect();
    };
  };

  const reconnect = () => {
    if (reconnectAttempts < 5) {
      reconnectAttempts++;
      setTimeout(() => {
        connect();
      }, 1000 * reconnectAttempts);
    }
  };

  connect();

  return {
    socket: socket.value,
  };
}
